import __var_0__ from './main.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Reverse a string.
*
* @module @stdlib/string/reverse
*
* @example
* var reverseString = require( '@stdlib/string/reverse' );
*
* var out = reverseString( 'last man standing' );
* // returns 'gnidnats nam tsal'
*
* out = reverseString( 'Hidden Treasures' );
* // returns 'serusaerT neddiH';
*/

// MODULES //
var reverseString = __var_0__;


// EXPORTS //
export default reverseString;
